import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

const headerHeight = 64;
const footerHeight = 72;

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      width: 900,
      maxWidth: '100%',
      height: '100%',
    },
    header: {
      position: 'relative',
      padding: spacing(3, 6),
    },
    createHeader: {
      height: headerHeight,
      fontWeight: 500,
    },
    headerBtn: {
      border: 'none',
      height: 40,
      width: 40,
    },
    headerIcon: {
      color: '#9EA6B3', //TODO change after creating new palette
    },
    headingIconContainer: {
      width: 48,
      height: 48,
      borderRadius: '50%',
      backgroundColor: '#EAECF0', //TODO change after creating new palette
      flex: '0 0 auto',
      marginRight: spacing(3),
    },
    headingIcon: {
      fontSize: 20,
    },
    headingInfoContainer: {
      flex: '1 1 auto',
    },
    headingCompanyName: {
      color: '#101828', //TODO change after creating new palette,
      lineHeight: '30px',
      fontSize: 20,
      fontWeight: 500,
    },
    contactNumber: {
      color: '#7E8899', //TODO replace after creating new palette
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
    },
    content: {
      height: `calc(100% - ${headerHeight}px - ${footerHeight}px)`,
      padding: spacing(6),
      overflow: 'auto',
    },
    companyName: {
      fontSize: 15,
      fontWeight: 500,
    },
    companyAddress: {
      color: '#7E8899', //TODO replace after creating new palette
      fontSize: 12,
      fontWeight: 500,
    },
    block: {
      padding: spacing(6),
      backgroundColor: colors.grey.body,
      borderRadius: 8,
      '&:not(:last-child)': {
        marginBottom: spacing(6),
      },
    },
    blockTitle: {
      fontSize: 16,
      fontWeight: 600,
      display: 'inline-block',
      marginBottom: spacing(4),
    },
    row: {
      marginBottom: spacing(6),

      '&> *:first-child': {
        marginRight: spacing(4),
      },
    },
    rowElement: {
      width: '50%',
      // If there's only one element in the row, padding aligns it with rows that have two
      '&:only-child': {
        paddingRight: spacing(2),
      },
    },
    fullRowElement: {
      width: '100%',
    },
    label: {
      display: 'inline-block',
      marginBottom: spacing(2),
      fontWeight: 500,
      lineHeight: '16px',
      color: '#1D2433', //TODO replace after creating new palette
    },
    divider: {
      backgroundColor: '#EAECF0', //TODO change after creating new palette
      height: 1,
      margin: spacing(8, 0),
      width: '100%',
    },
    investorProfileRow: {
      alignItems: 'center',
      gap: spacing(4),
    },
    investorProfileElement: {
      width: `calc(50% - ${spacing(2)}px)`,
    },
    radioGroup: {
      flexDirection: 'row',
      marginTop: spacing(3),
    },
    radioGroupLabel: {
      paddingTop: 0,
    },
    radioGroupFrom: {
      marginBottom: 0,
    },
    fullWidthSelect: {
      width: '100%',
    },
    editAddressBtn: {
      marginLeft: spacing(3),
    },
    drawerOverlay: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
    withBorder: {
      borderBottom: '1px solid #EAECF0', //TODO change after creating new palette
      boxShadow: 'none',
      zIndex: 2,
    },
    saveBtn: {
      marginLeft: spacing(2),
    },
    secondaryAddressBtn: {
      marginTop: spacing(4),
    },
    footer: {
      backgroundColor: colors.white.lightest,
      borderTop: '1px solid #EAECF0', //TODO change after creating new palette,
      height: footerHeight,
      padding: spacing(3, 6),
      right: 0,
      width: '100%',
    },
  });
